module.exports = __webpack_public_path__ + "img/118.2d16568a.jpg";